import { cn } from "@/lib/utils";

// Dense data table with sticky glass header (RFC-0004). Columns: {key,label,align,render,className}.
export function DataTable({ columns, rows, rowKey = "id", empty, onRowClick, testId, className }) {
  const align = (a) => (a === "right" ? "text-right" : a === "center" ? "text-center" : "text-left");

  if (!rows?.length && empty) return empty;

  return (
    <div className={cn("overflow-hidden rounded-lg border border-border bg-card", className)}>
      <div className="overflow-x-auto">
        <table className="w-full text-sm" data-testid={testId || "data-table"}>
          <thead className="promo-glass sticky top-0 z-10">
            <tr className="border-b border-border">
              {columns.map((c) => (
                <th
                  key={c.key}
                  className={cn(
                    "px-4 py-3 font-medium text-muted-foreground promo-overline whitespace-nowrap",
                    align(c.align),
                    c.className,
                  )}
                >
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr
                key={row[rowKey] || i}
                onClick={onRowClick ? () => onRowClick(row) : undefined}
                className={cn(
                  "border-b border-border/60 transition-colors last:border-0",
                  onRowClick && "cursor-pointer hover:bg-accent/40",
                )}
                data-testid={`table-row-${row[rowKey] || i}`}
              >
                {columns.map((c) => (
                  <td key={c.key} className={cn("px-4 py-3 tabular-nums", align(c.align), c.cellClassName)}>
                    {c.render ? c.render(row) : row[c.key]}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
